import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/svg/icon-sprite.svg'


const _hoisted_1 = _imports_0 + '#stroke-home'
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "page-title mt-2" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-sm-6 ps-0" }
const _hoisted_6 = { class: "col-sm-6 pe-0" }
const _hoisted_7 = { class: "breadcrumb" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = {
  key: 0,
  class: "breadcrumb-item"
}
const _hoisted_10 = {
  key: 1,
  class: "breadcrumb-item active"
}
const _hoisted_11 = {
  key: 2,
  class: "breadcrumb-item active"
}



export default /*@__PURE__*/_defineComponent({
  __name: 'breadCrumbs',
  props: {
    title: {
        default: 'home'
    },
    main: {
        default: ''
    },
    mains: {
        default: ''
    },
    titles: {
        default: ''
    }
},
  setup(__props) {

let props = __props

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_2, [
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", null, _toDisplayString(__props.title), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ol", _hoisted_7, [
            _createElementVNode("li", _hoisted_8, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createElementVNode("svg", { class: "stroke-icon" }, [
                    _createElementVNode("use", { href: _hoisted_1 })
                  ], -1)
                ])),
                _: 1
              })
            ]),
            (__props.main)
              ? (_openBlock(), _createElementBlock("li", _hoisted_9, _toDisplayString(__props.main), 1))
              : _createCommentVNode("", true),
            (__props.titles)
              ? (_openBlock(), _createElementBlock("li", _hoisted_10, _toDisplayString(__props.titles), 1))
              : _createCommentVNode("", true),
            (__props.mains)
              ? (_openBlock(), _createElementBlock("li", _hoisted_11, _toDisplayString(__props.mains), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})